import React from 'react';
import { Label } from './Label';
import { AddOnItem } from '~/types/models/addon';
import { EmptyValuePlaceholder } from '../../Common/EmptyValuePlaceholder';

export interface AddOnsPanelProps {
  addOns?: AddOnItem[];
}

export function AddOnsPanel({ addOns }: AddOnsPanelProps) {
  return (
    <div className='flex flex-col gap-y-4'>
      <Label>Add-ons</Label>
      {addOns && addOns?.length > 0 ? (
        addOns.map((addOn) => {
          return (
            <span
              key={addOn.uuid}
              className='flex flex-row gap-x-6 flex v2-text-neutral-900 items-center justify-between'
            >
              <span className='flex flex-row gap-x-4 items-center text-base font-bold flex-wrap'>
                <span className='flex flex-row gap-x-3 items-center'>
                  <img
                    className='rounded v2-bg-white w-8 h-8 p-1 border border-solid v2-border-neutral-300'
                    src={addOn.icon}
                  />
                  <span>{addOn.label} </span>
                </span>
                {addOn.quantity && <span>X {addOn.quantity} </span>}
              </span>
              {!addOn.cancelled && (
                <span className='text-[21px] v2-text-neutral-900'>
                  ${addOn.price}
                </span>
              )}
            </span>
          );
        })
      ) : (
        <EmptyValuePlaceholder />
      )}
    </div>
  );
}
